<!-- StepFour.vue -->
<template>
    <div class="space-y-4">
        <!-- <div>
            <label class="label">Upload ID Document</label>
            <input
                type="file"
                @change="uploadFile('idDocument')"
            />
        </div>
        <div>
            <label class="label">Registration Certificate</label>
            <input
                type="file"
                @change="uploadFile('registrationCertificate')"
            />
        </div>
        <div>
            <label class="label">VAT Registration Certificate</label>
            <input
                type="file"
                @change="uploadFile('vatRegistrationCertificate')"
            />
        </div> -->
        <!-- Documents  -->
        <div>
            <div class="mx-2 text-xl font-semibold">Documents*</div>

            <div class="grid grid-cols-1 gap-6 m-2 lg:grid-cols-3">
                <!-- id_document -->
                <div class="relative group">
                    <label class="text-sm font-semibold text-gray-700">
                        <span>One Form ID *</span>
                    </label>

                    <div @click="replaceImage('id-document')">
                        <img
                            v-if="idDocumentPreview"
                            class="object-cover object-center max-w-full rounded h-36"
                            :src="idDocumentPreview"
                        />

                        <div
                            v-else
                            class="relative font-medium text-green-600 bg-white rounded-md cursor-pointer hover:text-green-500"
                        >
                            <div
                                class="flex justify-center px-6 pt-5 pb-6 mt-2 rounded-md"
                                :class="
                                    localErrors('id_document')
                                        ? 'border-2 border-red-300 border-dashed'
                                        : 'border-2 border-gray-300 border-dashed'
                                "
                            >
                                <div class="flex flex-col items-center justify-center space-y-1 text-center">
                                    <FileUploadIcon />
                                    <div class="flex items-center justify-center text-sm text-gray-600">
                                        <span>Upload One form of ID</span>
                                    </div>
                                    <p class="text-xs text-gray-500">PNG, JPG, GIF up to 5MB</p>
                                </div>
                            </div>
                        </div>

                        <!-- image input -->
                        <input
                            ref="id-document-image-upload"
                            class="hidden"
                            type="file"
                            @change="filesChange($event.target.files, 'id-document')"
                        />
                    </div>

                    <div
                        v-if="localErrors('id_document')"
                        class="text-red-500"
                    >
                        {{ localErrors('id_document') }}
                    </div>
                </div>

                <!-- registration certificate -->
                <div class="relative group">
                    <label class="text-sm font-semibold text-gray-700">
                        <span>Business Registration Certificate *</span>
                    </label>
                    <div @click="replaceImage('registration-certificate')">
                        <img
                            v-if="registrationCertificatePreview"
                            class="object-cover object-center max-w-full rounded h-36"
                            :src="registrationCertificatePreview"
                        />

                        <div
                            v-else
                            class="relative font-medium text-green-600 bg-white rounded-md cursor-pointer hover:text-green-500"
                        >
                            <div
                                class="flex justify-center px-6 pt-5 pb-6 mt-2 rounded-md"
                                :class="
                                    localErrors('registration_certificate')
                                        ? 'border-2 border-red-300 border-dashed'
                                        : 'border-2 border-gray-300 border-dashed'
                                "
                            >
                                <div class="flex flex-col items-center justify-center space-y-1 text-center">
                                    <FileUploadIcon />
                                    <div class="flex items-center justify-center text-sm text-gray-600">
                                        <span>Upload Registration Certificate</span>
                                    </div>
                                    <p class="text-xs text-gray-500">PNG, JPG, GIF up to 5MB</p>
                                </div>
                            </div>
                        </div>

                        <!-- image input -->
                        <input
                            ref="registration-certificate-image-upload"
                            class="hidden"
                            type="file"
                            @change="filesChange($event.target.files, 'registration-certificate')"
                        />
                    </div>

                    <div
                        v-if="localErrors('registration_certificate')"
                        class="text-red-500"
                    >
                        {{ localErrors('registration_certificate') }}
                    </div>
                </div>

                <!-- Vat certificate -->
                <div v-if="isWholesaler">
                    <!-- accept_vat checkbox -->
                    <!-- <div>
                                    <div class="flex mt-1 rounded-md shadow-sm">
                                        <label class="flex items-center">
                                            <span class="ml-2">Accept Vat from Retailers</span>
                                        </label>
                                    </div>
                                </div> -->

                    <!-- vat-certificate -->
                    <div class="relative group">
                        <label class="text-sm font-semibold text-gray-700">
                            <t-checkbox v-model="form.acceptVat" />
                            <span>Accept Vat</span>
                        </label>
                        <div @click="replaceImage('vat-registration')">
                            <img
                                v-if="vatRegistrationCertificatePreview"
                                class="object-cover object-center max-w-full rounded h-36"
                                :src="vatRegistrationCertificatePreview"
                            />

                            <div
                                v-else
                                class="relative font-medium text-green-600 bg-white rounded-md hover:text-green-500"
                                :class="form.acceptVat ? 'cursor-pointer' : 'cursor-default opacity-50'"
                            >
                                <div
                                    class="flex justify-center px-6 pt-5 pb-6 mt-2 rounded-md"
                                    :class="
                                        localErrors('vat_registration_certificate')
                                            ? 'border-2 border-red-300 border-dashed'
                                            : 'border-2 border-gray-300 border-dashed'
                                    "
                                >
                                    <div class="flex flex-col items-center justify-center space-y-1 text-center">
                                        <FileUploadIcon />
                                        <div class="flex items-center justify-center text-sm text-gray-600">
                                            <span>Upload Vat Certificate</span>
                                        </div>
                                        <p class="text-xs text-gray-500">PNG, JPG, GIF up to 5MB</p>
                                    </div>
                                </div>
                            </div>

                            <!-- image input -->
                            <input
                                ref="vat-registration-image-upload"
                                :disabled="form.acceptVat ? false : true"
                                class="hidden"
                                type="file"
                                @change="filesChange($event.target.files, 'vat-registration')"
                            />
                        </div>
                        <div
                            v-if="localErrors('vat_registration_certificate')"
                            class="mt-4 text-red-500"
                        >
                            {{ localErrors('vat_registration_certificate') }}
                        </div>
                    </div>
                </div>

                <!-- file upload -->
                <div class="relative group">
                    <label class="text-sm font-semibold text-gray-700">
                        <span>Other Supportive Documents (Multiple)</span>
                    </label>
                    <FileUpload
                        :multiple="true"
                        @filesUploaded="attachFilesToForm"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from '@/Components/FileUpload.vue';
    import FileUploadIcon from '@/Components/Icons/FileUploadIcon.vue';
    export default {
        name: 'KYCStepFour',
        components: {
            FileUpload,
            FileUploadIcon,
        },
        props: {
            form: { type: Object, required: true },
            errors: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                idDocumentPreview: this.form.idDocumentPreview || null,
                registrationCertificatePreview: this.form.registrationCertificatePreview || null,
                vatRegistrationCertificatePreview: this.form.vatRegistrationCertificatePreview || null,
            };
        },
        computed: {
            localErrors() {
                return this.errors || {};
            },
        },
        methods: {
            // uploadFile(field) {
            //     return (e) => {
            //         const file = e.target.files[0];
            //         if (file) {
            //             const reader = new FileReader();
            //             reader.onload = (e) => {
            //                 this.$emit('updateForm', { [field]: e.target.result });
            //             };
            //             reader.readAsDataURL(file);
            //         }
            //     };
            // },
            attachFilesToForm(files) {
                this.form.images = files;
            },

            filesChange(fileList, type) {
                if (!fileList.length) return;
                if (type === 'logo') {
                    this.form.logo = fileList[0];
                    this.getImagePreviews('logo');
                }
                if (type === 'id-document') {
                    this.form.idDocument = fileList[0];
                    this.getImagePreviews('idDocument');
                }
                if (type === 'registration-certificate') {
                    this.form.registrationCertificate = fileList[0];
                    this.getImagePreviews('registrationCertificate');
                }
                if (type === 'vat-registration') {
                    this.form.vatRegistrationCertificate = fileList[0];
                    this.getImagePreviews('vatRegistrationCertificate');
                }
            },

            getImagePreviews(attributeName) {
                if (/\.(jpe?g|png|gif)$/i.test(this.form[attributeName].name)) {
                    const reader = new FileReader();
                    reader.addEventListener(
                        'load',
                        () => {
                            const dataAttributeName = `${attributeName}Preview`;
                            this[dataAttributeName] = reader.result;
                        },
                        false,
                    );

                    reader.readAsDataURL(this.form[attributeName]);
                }
            },

            replaceImage(type) {
                this.$refs[`${type}-image-upload`].click();
            },
        },
    };
</script>
